<script setup>
import { PlayerStore } from '@/front/stores/player_store.js'
import { ClickStore } from '@/front/stores/click_store.js'
import { AnnStore } from '@/front/stores/ann_store.js'
import { VideoStore } from '@/front/stores/video_store.js'
import { ClipStore } from '@/front/stores/clip_store.js'
const videoStore = VideoStore()
const clipStore = ClipStore()
import { finishClip } from '@/front/composables/ClickComposer.js'
import { PositionCalculator } from '@/front/composables/PositionCalculator.js'
const { calculatePosition } = PositionCalculator()
const playerStore = PlayerStore()
const clickStore = ClickStore()
const annStore = AnnStore()
import ClipPlayer from '@/front/components/ClipPlayer.vue';

import Button from 'primevue/button';
import { Cancel01Icon } from 'hugeicons-vue';
const { t } = useI18n({});
// Have to calcualte aspect ratio to pin layer to actual video
// LATER handle cover mode

const handleEnded = () => {
  log.info(3,"ClipLayer handleEnded")
  // finishClip()
}

const props = defineProps({
  ann: {
    type: Object,
    default: null,
  },
})

onMounted(() => {
  log.info(3,"ClipLayer onMounted", props.ann)
})

const styling = computed(() => {
  log.info(3,"ClipLayer styling", props.ann)
  // Click-action clips (no annotation) should fill the available player area
  // and rely on media object-fit contain to stay centered without distortion.
  if (!props.ann) {
    return {
      content: {
        width: '100%',
        height: '100%',
        left: '0px',
        top: '0px',
        minHeight: '0px',
        aspectRatio: 'auto',
      },
    }
  }
  // LATER make sure this doesnt break in diff context
  const dimensions = calculatePosition(props.ann)
  return {
    content: {
      'width': `${dimensions.width}px`,
      'height': `${dimensions.height}px`,
      'left': `${dimensions.left}px`,
      'top': `${dimensions.top}px`,
      'minHeight': `${dimensions.minHeight}px`,
      'fontSize': `${dimensions.fontSize}px`,
      'textAlign': props.ann.textAlign || 'center',
      // LATER line height, make sure doesnt mess up old ones
    },
  }
})

const canSkip = computed(() => {
  return videoStore.video.can_skip_clips || videoStore.video.manage
})

const getVolume = computed(() => {
  return playerStore.originalVolume
  // let v =  playerStore.isMuted ? 0 : playerStore.getVolume
  // log.info(3,"getVolume", v)
  // return v
})


</script>

<template>
  <div id="clip-layer" class="absolute w-full h-full left-0 top-0 z-[10] flex items-center justify-center">
    <ClipPlayer v-if="clipStore.src" :style="styling.content" :controls="false" @ended="finishClip" :loop="annStore.isEditing" :volume="getVolume"/>
    <Button v-if="canSkip" @click.stop="finishClip" class="!absolute top-1 right-1 !bg-[var(--user-theme-color)]" rounded size="small">
      <Cancel01Icon :size="20" class="text-red font-bold text-white" />
    </Button>
  </div>
</template>

<style>
#clip-layer video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
